import React, { useState } from 'react';
import { calculateLiquidFull } from '../utils/calculators';

export default function LiquidHelper() {
    const [form, setForm] = useState({
        weight: "",
        dehydration: "",
        aminoType: "Amino Asit Seçiniz",
        isBicarb: false,
        isAbnormal: false,
        isHepatit: false
    });
    const [result, setResult] = useState(null);

    const handleCalculate = () => {
        if (!form.weight || !form.dehydration) {
            alert("Lütfen ağırlık ve dehidrasyon oranını giriniz.");
            return;
        }
        const res = calculateLiquidFull(form);
        setResult(res);

        if (res.showMetabolaseWarning) {
            alert("Metabolase Uyarısı: Kedi ve Tavşanlarda sadece SC (deri altı) uygulanır.");
        }
    };

    const showDehidreInfo = () => {
        alert("Dehidrasyon Tablosu\n\n• %5-6: Hafif elastikiyet kaybı\n• %6-8: Orta derece (Kuru mukoza, çökük göz)\n• %10-12: Şok durumu, ciddi perfüzyon bozukluğu");
    };

    return (
        <div style={containerStyle}>
            <h2 style={{ textAlign: 'center', color: '#2c3e50', marginBottom: '5px' }}>💧 Sıvı Tedavi Asistanı</h2>
            <p style={{ textAlign: 'center', color: '#7f8c8d', fontSize: '13px', marginBottom: '25px' }}>Dehidrasyon ve İdame Hesaplama</p>

            <div style={cardStyle}>
                {/* Canlı Ağırlık */}
                <div style={inputGroup}>
                    <label style={labelStyle}>CANLI AĞIRLIK (KG)</label>
                    <input 
                        type="number" 
                        placeholder="0.0"
                        onChange={(e) => setForm({...form, weight: e.target.value})} 
                        style={inputStyle} 
                    />
                </div>

                {/* Dehidrasyon Oranı */}
                <div style={inputGroup}>
                    <label style={labelStyle}>DEHİDRASYON ORANI (%)</label>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <input 
                            type="number" 
                            placeholder="5"
                            onChange={(e) => setForm({...form, dehydration: e.target.value})} 
                            style={{ ...inputStyle, flex: 1 }} 
                        />
                        <button onClick={showDehidreInfo} style={infoCircleBtn}>?</button>
                    </div>
                </div>

                {/* Amino Asit Seçimi */}
                <div style={inputGroup}>
                    <div style={{ marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                        <input type="checkbox" checked={form.isAbnormal} onChange={(e) => setForm({...form, isAbnormal: e.target.checked})} id="abnormal" />
                        <label htmlFor="abnormal" style={{ marginLeft: '10px', fontSize: '14px', color: '#2c3e50', fontWeight: 'bold' }}>Anormal Kayıplar (Amino Asit)</label>
                    </div>
                    <select 
                        disabled={!form.isAbnormal} 
                        value={form.aminoType} 
                        onChange={(e) => setForm({...form, aminoType: e.target.value})} 
                        style={{ ...selectStyle, opacity: form.isAbnormal ? 1 : 0.5 }}
                    >
                        <option>Amino Asit Seçiniz</option>
                        <option>Metabolase</option>
                        <option>Neoton</option>
                        <option>Duphalite</option>
                    </select>
                </div>

                {/* Ek Koşullar */}
                <div style={checkGrid}>
                    <div style={checkItem}>
                        <input type="checkbox" onChange={(e) => setForm({...form, isHepatit: e.target.checked})} id="hepatit" />
                        <label htmlFor="hepatit" style={checkLabel}>Hepatit Şüphesi</label>
                    </div>
                    <div style={checkItem}>
                        <input type="checkbox" onChange={(e) => setForm({...form, isBicarb: e.target.checked})} id="bicarb" />
                        <label htmlFor="bicarb" style={checkLabel}>Bikarbonat İhtiyacı</label>
                    </div>
                </div>

                <button onClick={handleCalculate} style={calcBtn}>HESAPLA</button>
            </div>

            {/* SONUÇ ALANI */}
            {result && (
                <div style={resultBox}>
                    <h3 style={{ color: '#27ae60', marginTop: 0 }}>📊 Tedavi Planı</h3>
                    <div style={totalResultBadge}>{`Toplam Açık: ${result.totalFluid} ml`}</div>
                    <pre style={guideText}>{result.guide}</pre>
                    
                    {form.isBicarb && (
                        <div style={bicarbBox}>
                            <h4 style={{ margin: '0 0 5px 0', color: '#2980b9' }}>⚖️ Bikarbonat Desteği</h4>
                            <p style={{ margin: '0' }}>{`İhtiyaç: ${result.bicarbMg} mg`}</p>
                            <p style={{ margin: '0', fontWeight: 'bold' }}>{`Sodyum Bikarbonat (%8.4): ${result.bicarbMl} ml`}</p>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

// --- CSS STİLLERİ (Mobil ve iOS Safe-Area Uyumlu) ---
const containerStyle = { 
    padding: '15px', 
    maxWidth: '500px', 
    margin: '0 auto', 
    fontFamily: "'Segoe UI', sans-serif",
    boxSizing: 'border-box',
    width: '100%',
    paddingTop: 'max(15px, env(safe-area-inset-top))', 
    paddingBottom: 'env(safe-area-inset-bottom)'      
};

const cardStyle = { 
    background: '#fff', 
    padding: '20px', 
    borderRadius: '15px', 
    boxShadow: '0 10px 25px rgba(0,0,0,0.08)', 
    border: '1px solid #eee',
    boxSizing: 'border-box',
    width: '100%'
};

const inputGroup = { marginBottom: '20px', boxSizing: 'border-box' };
const labelStyle = { display: 'block', fontSize: '11px', fontWeight: 'bold', color: '#7f8c8d', marginBottom: '8px', textTransform: 'uppercase' };

const inputStyle = { 
    width: '100%', 
    padding: '12px', 
    border: '2px solid #dfe6e9', 
    borderRadius: '10px', 
    fontSize: '16px', 
    boxSizing: 'border-box',
    outline: 'none',
    WebkitAppearance: 'none'
};

const selectStyle = { 
    width: '100%', 
    padding: '12px', 
    background: '#f8f9fa', 
    border: '1px solid #dfe6e9', 
    borderRadius: '10px', 
    fontSize: '15px',
    boxSizing: 'border-box',
    WebkitAppearance: 'none'
};

const infoCircleBtn = { width: '45px', background: '#34495e', color: 'white', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: 'bold', flexShrink: 0 };

const checkGrid = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', margin: '15px 0', boxSizing: 'border-box' };
const checkItem = { display: 'flex', alignItems: 'center' };
const checkLabel = { marginLeft: '8px', fontSize: '13px', color: '#2c3e50', fontWeight: '500' };

const calcBtn = { width: '100%', padding: '16px', background: 'linear-gradient(135deg, #27ae60 0%, #2ecc71 100%)', color: 'white', border: 'none', borderRadius: '12px', fontWeight: 'bold', fontSize: '16px', cursor: 'pointer', boxShadow: '0 5px 15px rgba(46, 204, 113, 0.3)', boxSizing: 'border-box', WebkitTapHighlightColor: 'transparent' };

const resultBox = { marginTop: '20px', padding: '20px', background: '#fff', borderRadius: '15px', borderLeft: '8px solid #27ae60', boxShadow: '0 5px 20px rgba(0,0,0,0.05)', boxSizing: 'border-box', width: '100%' };
const totalResultBadge = { background: '#eafaf1', color: '#27ae60', padding: '10px', borderRadius: '8px', fontWeight: 'bold', fontSize: '18px', textAlign: 'center', marginBottom: '15px', boxSizing: 'border-box' };
const guideText = { whiteSpace: 'pre-wrap', color: '#34495e', fontSize: '14px', lineHeight: '1.6', fontFamily: 'inherit', wordBreak: 'break-word' };
const bicarbBox = { marginTop: '15px', padding: '12px', background: '#ebf5fb', borderRadius: '8px', border: '1px solid #aed6f1', boxSizing: 'border-box' };